import React from 'react';
import { MagneticButton } from '../common/MagneticButton';
import { PixelGlyph } from '../common/PixelGlyph';
import { SunsetStripe } from '../common/SunsetStripe';

export const GrandFinale: React.FC = () => {
  return (
    <section
      id="contact"
      className="relative py-20 sm:py-28 md:py-36 px-4 sm:px-6 max-w-5xl mx-auto text-center z-10"
      aria-label="Grand Finale CTA"
    >
      {/* Background Radial Glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[320px] sm:w-[600px] h-[220px] sm:h-[350px] bg-gradient-to-r from-sunset-gold/15 via-sunset-flame/15 to-sunset-crimson/15 blur-[80px] sm:blur-[120px] pointer-events-none rounded-full"
        aria-hidden="true"
      />

      <div className="relative z-10">
        <div className="inline-flex items-center gap-2 sm:gap-2.5 px-3.5 sm:px-4 py-1.5 rounded-full bg-espresso-900/90 border border-white/10 shadow-bezel-inner text-[10px] sm:text-[11px] font-mono tracking-ultra uppercase text-sunset-gold mb-6 sm:mb-8">
          <PixelGlyph name="pulse-dot" size={8} />
          <span>FINALE // READY TO TRANSCEND THE ORDINARY?</span>
        </div>

        <h2 className="font-display font-extrabold text-3xl sm:text-5xl md:text-6xl lg:text-7xl text-cream-100 tracking-tight leading-[1.1] mb-6 sm:mb-8 text-balance">
          Let's build experiences that{' '}
          <span className="bg-gradient-to-r from-sunset-gold via-gold-radiance to-sunset-flame bg-clip-text text-transparent">
            leave them breathless
          </span>
          .
        </h2>

        <p className="max-w-xl mx-auto text-sm sm:text-lg text-cream-muted leading-relaxed mb-8 sm:mb-12 text-balance">
          From bespoke WebGL choreography and 120 FPS fluid kinematics to production-grade web systems. Available for select high-ambition client commissions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 mb-12 sm:mb-16 w-full sm:w-auto">
          <MagneticButton
            variant="sunset"
            size="lg"
            href="https://t.me/TH157LECLAW"
            target="_blank"
            rel="noopener noreferrer"
            showArrow={true}
            className="w-full sm:w-auto justify-center"
          >
            Telegram: @TH157LECLAW
          </MagneticButton>

          <MagneticButton
            variant="secondary"
            size="lg"
            href="mailto:support@th157le.ru"
            showArrow={true}
            className="w-full sm:w-auto justify-center"
          >
            support@th157le.ru
          </MagneticButton>
        </div>

        <SunsetStripe height="h-1.5 sm:h-2" className="max-w-md mx-auto rounded-full" />
      </div>
    </section>
  );
};
